/**
 * VERIFIED BADGE COMPONENT
 * 
 * Displays a verification badge next to verified wallet addresses
 * Can be used in profile headers, piece listings, creator cards, etc.
 * 
 * Supports two types of verification:
 * - 'sales_milestone': Earned by reaching 500 sales (chrome badge)
 * - 'paid': Purchased with 0.1 SOL (white badge)
 * - 'manual': Manually verified by admin (chrome badge)
 */

export default function VerifiedBadge({ 
  size = 'md',  // 'sm', 'md', 'lg'
  className = '',
  tooltip = 'Verified Creator',
  verificationType = 'sales_milestone' // 'sales_milestone', 'paid', 'manual', or 'none'
}) {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  // Determine which badge to show based on verification type
  const badgeImage = verificationType === 'paid' 
    ? '/images/Paid verification.png' 
    : '/images/Verification badge.png';
  
  // Update tooltip based on verification type
  const badgeTooltip = verificationType === 'paid'
    ? 'Premium Verified Creator'
    : tooltip;

  return (
    <img 
      src={badgeImage} 
      alt="Verified" 
      className={`${sizes[size]} object-contain flex-shrink-0 ${className}`}
      title={badgeTooltip}
    />
  );
}

